// extracted by mini-css-extract-plugin
module.exports = {"header":"_3gC_Bb","paymentImage":"Hll24N","paymentName":"_3FqDE2","cardImage":"_VNlz6","shine-lines":"CIO3-o"};